export function findExactCanonicalIssuer(issuers = [], issuerName = "") {
  if (!issuerName || !Array.isArray(issuers)) return null;

  const matches = issuers.filter(
    (issuer) => issuer?.id && issuer?.legal_name === issuerName
  );

  return matches.length === 1 ? matches[0] : null;
}

export function matchesIssueIssuer({
  deal,
  issuerId = null,
  issuerName = "",
}) {
  if (issuerId) return deal?.issuer_id === issuerId;
  if (!issuerName) return false;

  const candidateName = deal?.issuer_id
    ? deal?.issuers?.legal_name ?? deal?.issuer_name
    : deal?.issuer_name_raw ?? deal?.issuerNameRaw;

  return candidateName === issuerName;
}
